import Image from 'next/image';
import type { ImageProps } from 'next/image';
import { useState } from 'react';
import styled from 'styled-components';

type Variant = 'header' | 'footer';

const ImageContainer = styled.div<{ variant: Variant }>(({ theme, variant }) => ({
  height: 125,
  width: '100%',
  position: 'relative',
  marginTop: variant === 'footer' ? theme.spacing[20] : 0,
  [`${theme.mediaBreakpointUp.lg}`]: {
    marginTop: variant === 'footer' ? theme.spacing[24] : 0,
    height: 245,
  },
}));

interface ISMEImageProps extends ImageProps {
  variant: Variant;
}

const SMEImage = ({ variant, ...rest }: ISMEImageProps) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) return null;

  return (
    <ImageContainer variant={variant}>
      <Image onError={() => setHasError(true)} style={{ objectFit: 'cover' }} fill {...rest} />
    </ImageContainer>
  );
};

export { SMEImage };
